import './PlaceholderBar.scss';

import React, { FunctionComponent } from 'react';

import classNames from 'classnames';

export type PlaceholderBarProps = {
  width?: string | number;
  height?: string | number;
  colour?: 'nobel' | 'very-light-grey';
  marginTop?: string | number;
  marginBottom?: string;
  marginLeft?: string | number;
  marginRight?: string | number;
  animated?: boolean;
  className?: string;
};

export const PlaceholderBar: FunctionComponent<PlaceholderBarProps> = ({
  width = '100%',
  height = '14px',
  colour = 'very-light-grey',
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  animated,
  className = '',
}) => {
  return (
    <span
      data-qa="placeholder-bar"
      className={classNames(
        'placeholderBar',
        { 'jg-background--very-light-grey': colour === 'very-light-grey' },
        { 'jg-background--nobel': colour === 'nobel' },
        `jg-background--${colour}`,
        { placeholderBarAnimated: animated },
        className,
      )}
      style={{
        height,
        width,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight,
      }}
      aria-hidden
    />
  );
};
